// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__788fk","modalContent":"Modal_modalContent__cUNmD","transparent":"Modal_transparent__29LW6"};